import { FC } from 'react';

import HighlightedText from 'common/components/custom/highlighted-text/HighlightedText';

import './SearchList.scss';
import { ICON_COLLECTION } from 'assets/media/icons';
import Icon from 'common/components/base/icon';

type SearchSelectionProps = {
    data: any;
    clearSelection: () => void;
};

const SearchSelection: FC<SearchSelectionProps> = ({
    data,
    clearSelection
}: SearchSelectionProps) => {
    return (
        <>
            <div className="search-container">
                <div className="search-content">
                    <div className="search-text">
                        <HighlightedText text={data.name} highlight={''} />
                    </div>
                    <div className="search-breadcrumb">{data.path}</div>
                </div>
                <div className="clear-icon">
                    <Icon src={ICON_COLLECTION.IC_Clear} onClick={clearSelection} />
                </div>
            </div>
        </>
    );
};

export default SearchSelection;
